const state = {
  data: {}
}

const actions = {
  async getPenalizeSupportingPoliciesData({ commit, rootState, state }) {
    if (!state.data['penalize_supporting_policies']) {
      let result = await TdUI.api.admin.dictbiz.getSelect('penalize_supporting_policies')
      if (result.code == 200) {
        state.data['penalize_supporting_policies'] = result.data.map(e => {
          return {
            key: e.dictKey,
            text: e.dictValue,
            data: e.remark ? JSON.parse(e.remark) : {}
          }
        })
      }
    }
    return state.data['penalize_supporting_policies']
  },
  async getPenalizeIsYellowWarnData({ commit, rootState, state }) {
    if (!state.data['penalize_is_yellow_warn']) {
      let result = await TdUI.api.admin.dictbiz.getSelect('penalize_is_yellow_warn')
      if (result.code == 200) {
        state.data['penalize_is_yellow_warn'] = result.data.map(e => {
          return {
            key: e.dictKey,
            text: e.dictValue,
            data: e.remark ? JSON.parse(e.remark) : {}
          }
        })
      }
    }

    return state.data['penalize_is_yellow_warn']
  },
  async getFlowTypeData({ commit, rootState, state }) {
    if (!state.data['flow']) {
      let result = await TdUI.api.admin.dictbiz.getSelect('flow')
      if (result.code == 200) {
        state.data['flow'] = result.data.map(e => {
          return {
            key: e.dictKey,
            text: e.dictValue,
            data: e.remark.includes('{') ? JSON.parse(e.remark) : e.remark == null ? '' : e.remark
          }
        })
      }
    }
    return state.data['flow']
  }
}
const mutations = {
  setData(state, data) {
    state.data = data
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
